__turbopack_context__.v({
  "audioButton": "BlockAudio-module-scss-module__WHWl7q__audioButton",
  "duration": "BlockAudio-module-scss-module__WHWl7q__duration",
  "durationLine": "BlockAudio-module-scss-module__WHWl7q__durationLine",
  "fade-in": "BlockAudio-module-scss-module__WHWl7q__fade-in",
  "iconWrapper": "BlockAudio-module-scss-module__WHWl7q__iconWrapper",
  "innerPlayLine": "BlockAudio-module-scss-module__WHWl7q__innerPlayLine",
  "innerProgressBar": "BlockAudio-module-scss-module__WHWl7q__innerProgressBar",
  "pauseIcon": "BlockAudio-module-scss-module__WHWl7q__pauseIcon",
  "playIcon": "BlockAudio-module-scss-module__WHWl7q__playIcon",
  "playLine": "BlockAudio-module-scss-module__WHWl7q__playLine",
  "player": "BlockAudio-module-scss-module__WHWl7q__player",
  "progressBar": "BlockAudio-module-scss-module__WHWl7q__progressBar",
  "root": "BlockAudio-module-scss-module__WHWl7q__root",
});
